import { render, staticRenderFns } from "./rubric_form.vue?vue&type=template&id=722e3aac&scoped=true&"
import script from "./rubric_form.vue?vue&type=script&lang=js&"
export * from "./rubric_form.vue?vue&type=script&lang=js&"
import style0 from "./rubric_form.vue?vue&type=style&index=0&id=722e3aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722e3aac",
  null
  
)

export default component.exports